import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { QueryKey } from 'lib/queryClient'
import { useApp } from 'containers/Bootstrap'
import { handleUser } from 'lib/sentry'

export function useUser() {
  const { authService } = useApp()

  const { data: user } = useQuery({
    queryKey: [QueryKey.fetchUser],
    queryFn: () => authService.fetchUser(),
    staleTime: 60 * 1000,
    initialData: authService.user ?? undefined,
  })

  useEffect(() => {
    if (!user) {
      return
    }

    handleUser(user)
  }, [user])

  return {
    user: user ?? null,
    hasPermission: authService.hasPermission.bind(authService),
    hasPermissions: authService.hasPermissions.bind(authService),
  }
}
